import React, { useState } from "react";
import { WhatsappLogo, FacebookLogo, Envelope, LinkSimple, Check } from "@phosphor-icons/react";
import { useI18n } from "../contexts/I18nContext";

export default function ShareButtons({ code, groupName }) {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);

  const message = t("join_group_message").replace("{groupName}", groupName).replace("{code}", code);
  const url = `${window.location.origin}/app/groups?code=${code}`;

  const share = (kind) => {
    if (kind === "whatsapp") window.open(`https://wa.me/?text=${encodeURIComponent(message + " " + url)}`, "_blank");
    if (kind === "facebook") window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(message)}`, "_blank");
    if (kind === "email") window.open(`mailto:?subject=${encodeURIComponent(t("join_group_subject"))}&body=${encodeURIComponent(message + "\n" + url)}`);
    if (kind === "copy") {
      navigator.clipboard?.writeText(`${message}\n${url}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  const btn = "w-11 h-11 rounded-full flex items-center justify-center transition-transform hover:scale-105 active:scale-95";

  return (
    <div className="flex items-center gap-3" data-testid="share-buttons">
      <button type="button" data-testid="share-whatsapp" onClick={() => share("whatsapp")} className={`${btn} bg-[#25D366] text-white`}>
        <WhatsappLogo size={22} weight="fill" />
      </button>
      <button type="button" data-testid="share-facebook" onClick={() => share("facebook")} className={`${btn} bg-[#1877F2] text-white`}>
        <FacebookLogo size={22} weight="fill" />
      </button>
      <button type="button" data-testid="share-email" onClick={() => share("email")} className={`${btn} bg-neutral-200 text-[#02371b]`}>
        <Envelope size={20} weight="fill" />
      </button>
      <button type="button" data-testid="share-copy" onClick={() => share("copy")} className={`${btn} bg-[#41a42b] text-white relative`}>
        {copied ? <Check size={20} weight="bold" /> : <LinkSimple size={20} weight="bold" />}
      </button>
      {copied && <span className="text-[11px] text-[#084d25] font-bold">{t("copied")}</span>}
    </div>
  );
}
